/* eslint-disable */
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import List from "./list";
import { useWebSocket } from "../../../api/websocket/WebSocketContext";
import TableLayout from "../../components/TableLayout";
import { edit_order_status, order_lists } from "../../../api/websocket/payload";
import { setOrderlist } from "../../../../redux/actions/action";
import { toast } from "react-toastify";
import { initialPage } from "../../../utils/staticdata";
import { dateFormat, downloadCSV, downloadXLSX } from "../../../utils/common";

const OrderManagement = () => {
  const { send, receivedMessage, isConnect } = useWebSocket();
  const dispatch = useDispatch();
  useEffect(() => {
    if (isConnect) {
      if (receivedMessage) {
        if (
          receivedMessage?.url === order_lists.url &&
          receivedMessage?.request?.is_export === false
        ) {
          if (receivedMessage?.response?.status === 200)
            dispatch(setOrderlist(receivedMessage?.response?.data));
          if (receivedMessage?.response?.status === 400)
            dispatch(setOrderlist(initialPage));
        }
        if (
          receivedMessage?.url === order_lists.url &&
          receivedMessage?.request?.is_export
        ) {
          const name =`Order-list-${dateFormat(new Date().toString())}`;
          if (receivedMessage?.response?.status === 200&&receivedMessage?.request?.file_type==='csv') {
            downloadCSV(receivedMessage?.response?.data?.data, name);
          }
          if (receivedMessage?.response?.status === 200&&receivedMessage?.request?.file_type==='xlsx') {
            downloadXLSX(receivedMessage?.response?.data?.data, name);
          }
          order_lists.request.is_export=false
          order_lists.request.file_type=""
        }

        if (receivedMessage?.url === edit_order_status.url) {
          if (receivedMessage?.response?.status === 200) {
            send(order_lists);
            toast.success("Order status updated successfully");
          }
        }
      }
    }
  }, [receivedMessage]);
  useEffect(() => {
    if (isConnect) {
      const message = order_lists;

      send(message);
    }
  }, [isConnect]);

  useEffect(() => {
    return () => {
      order_lists.request = {
        filter: "paid",
        limit: 10,
        page: 1,
        search: "",
        file_type: "",
        export_for:"",
        is_export: false,
        subscription_orders:'all'
      };
    };
  }, []);

  return (
    <TableLayout
      // isFilter
      isAdd={false}
      title={"Order List"}
      payload={order_lists}
    >
      <List />
    </TableLayout>
  );
};

export default OrderManagement;
